import { ProjectProcess } from '~/modules/projects/libs/types';


export const getProcessText = (processName?: string, taskName?: string) => {
  if (!processName) return '';
  return `${processName}${taskName ? ` > ${taskName}` : ''}`;
};

export const getFilterProcessTagInfo = (id: string, processes?: ProjectProcess[]) => {
  const matchedProcess = processes?.find((e) => e._id === id);
  if (matchedProcess)
    return {
      processName: matchedProcess.title,
    };

  const matchedProcessByTask = processes?.find((p) => p.tasks.find((t) => t._id === id));
  const matchedTask = processes?.flatMap((e) => e.tasks).find((t) => t._id === id);
  if (!matchedTask) return null;
  return {
    processName: matchedProcessByTask?.title,
    taskName: matchedTask.text,
  };
};
